import { useState, useCallback } from 'react';
import apiClient from '../utils/apiClient';

const useMeetSync = () => {
  const [meetStatus, setMeetStatus] = useState(null);
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [syncResult, setSyncResult] = useState(null);
  const [error, setError] = useState(null);

  const loadMeetStatus = useCallback(async (eventDbId) => {
    if (!eventDbId) return;
    
    setLoadingStatus(true);
    setError(null);
    
    try {
      const response = await apiClient.get(`/eventos/${eventDbId}/meet-status/`);
      const data = await response.json();
      
      if (response.ok && data.success) {
        setMeetStatus(data);
      } else {
        setError(data.message || 'Error al obtener estado de Meet');
      }
    } catch (err) {
      console.error('Error loading meet status:', err);
      setError('Error de conexión al obtener estado de Meet');
    } finally {
      setLoadingStatus(false);
    }
  }, []);

  const syncMeet = useCallback(async (eventDbId, force = false) => {
    if (!eventDbId) return;
    
    setSyncing(true);
    setError(null);
    setSyncResult(null);
    
    try {
      const url = force 
        ? `/eventos/${eventDbId}/sync-meet/?force=true`
        : `/eventos/${eventDbId}/sync-meet/`;
      
      const response = await apiClient.post(url, {});
      const data = await response.json();
      
      if (response.ok && data.success) {
        setSyncResult(data);
        // Recargar estado después de sincronizar
        await loadMeetStatus(eventDbId);
      } else {
        setError(data.message || 'Error al sincronizar Meet');
      }
    } catch (err) {
      console.error('Error syncing meet:', err);
      setError('Error de conexión al sincronizar Meet');
    } finally {
      setSyncing(false);
    }
  }, [loadMeetStatus]);

  const clearMeetData = useCallback(() => {
    setMeetStatus(null);
    setSyncResult(null);
    setError(null);
  }, []);

  return {
    meetStatus,
    loadingStatus,
    syncing,
    syncResult,
    error,
    loadMeetStatus,
    syncMeet,
    clearMeetData,
    setSyncing
  };
};

export default useMeetSync;
